var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 67,
    viewBox: "0 0 65 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4433 31.0412L24.7397 23.5203L32.6019 31.6223L49.8069 13.888C53.7811 17.9845 53.7811 24.6287 49.8069 28.7252L32.5016 46.5629C32.5016 46.5629 17.2005 31.0392 17.4453 31.0392",
    fill: "#5B836D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 5.47994C39.7603 5.47994 46.5873 8.39361 51.7211 13.6874C56.8549 18.9792 59.6836 26.0163 59.6836 33.5C59.6836 40.9837 56.8569 48.0208 51.7211 53.3126C46.5873 58.6043 39.7603 61.5201 32.5 61.5201C25.2397 61.5201 18.4127 58.6064 13.2789 53.3126C8.14506 48.0208 5.31636 40.9837 5.31636 33.5C5.31636 26.0163 8.14306 18.9792 13.2789 13.6874C18.4127 8.39568 25.2397 5.47994 32.5 5.47994ZM32.5 0C14.5508 0 0 14.9985 0 33.5C0 52.0015 14.5508 67 32.5 67C50.4492 67 65 52.0015 65 33.5C65 14.9985 50.4492 0 32.5 0Z",
    fill: "#5B836D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4997 8.16608C30.5075 8.16608 28.8926 9.83074 28.8926 11.8842C28.8926 13.9376 30.5075 15.6022 32.4997 15.6022C34.4918 15.6022 36.1068 13.9376 36.1068 11.8842C36.1068 9.83074 34.4918 8.16608 32.4997 8.16608Z",
    fill: "#5B836D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5295 29.7819C9.53733 29.7819 7.92236 31.4466 7.92236 33.5C7.92236 35.5534 9.53733 37.2181 11.5295 37.2181C13.5216 37.2181 15.1366 35.5534 15.1366 33.5C15.1366 31.4466 13.5216 29.7819 11.5295 29.7819Z",
    fill: "#5B836D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4704 29.7819C51.4782 29.7819 49.8633 31.4466 49.8633 33.5C49.8633 35.5534 51.4782 37.2181 53.4704 37.2181C55.4625 37.2181 57.0775 35.5534 57.0775 33.5C57.0775 31.4466 55.4625 29.7819 53.4704 29.7819Z",
    fill: "#5B836D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4997 51.3976C30.5075 51.3976 28.8926 53.0623 28.8926 55.1157C28.8926 57.1692 30.5075 58.8338 32.4997 58.8338C34.4918 58.8338 36.1068 57.1692 36.1068 55.1157C36.1068 53.0623 34.4918 51.3976 32.4997 51.3976Z",
    fill: "#5B836D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgB);
export default __webpack_public_path__ + "static/media/b.5984addbed67c24807c9a4e0e1877289.svg";
export { ForwardRef as ReactComponent };